/* eslint-disable */
export default {
  businessUnit: 1,
  region: 1,
  language: window.ctsautoconf && window.ctsautoconf.language || 'UK',
  priceFormat: 'US',
  liveMarketsMTCGFlag: 'SHOWONCDU',
  liveBettingDataSourceType: '', // - PULL - use kansas; leave it empty for auto switch push/pull
  environmentName: process.env.NODE_ENV, // environment name
  contentServerHostname: (!window.ctsautoconf.CONTENT_SERVER_HOSTNAME || window.ctsautoconf.CONTENT_SERVER_HOSTNAME.indexOf('//') === -1 ? '//' : '') +
    window.ctsautoconf.CONTENT_SERVER_HOSTNAME_PREFIX +
    (window.ctsautoconf.CONTENT_SERVER_HOSTNAME ||
    (window.location.hostname + (window.location.port != '' ? (window.location.port != '80' ? ':' + window.location.port : '') : ''))),
  webServerHostname: (!window.ctsautoconf.WEB_SERVER_HOSTNAME || window.ctsautoconf.WEB_SERVER_HOSTNAME.indexOf('//') === -1 ? '//' : '') +
    ((window.ctsautoconf.WEB_SERVER_HOSTNAME) ||
      (window.location.hostname + (window.location.port != '' ? (window.location.port != '80' ? ':' + window.location.port : '') : ''))),
  webPushServiceHostname: (window.ctsautoconf && window.ctsautoconf.WEBPUSH_SERVICE_HOSTNAME) || '',
  teamLogoHostname: (window.ctsautoconf && window.ctsautoconf.TEAM_LOGO_HOSTNAME) || '',
  portPerEnvironment: window.ctsautoconf && window.ctsautoconf.portPerEnvironment ? window.ctsautoconf.portPerEnvironment : {
    'default': ''
  },
  carouselRotationInterval: (window.ctsautoconf && window.ctsautoconf.carouselRotationInterval) || 15000,
  statsRotationInterval: (window.ctsautoconf && window.ctsautoconf.statsRotationInterval) || 5000,
  screensRotationInterval: (window.ctsautoconf && window.ctsautoconf.screensRotationInterval) || 15000,
  outrightScreensRotationInterval: (window.ctsautoconf && window.ctsautoconf.outrightScreensRotationInterval) || 15000,
  dateFormats: {
    longDate: 'MM/DD/YYYY',
    shortDate: 'M/D/YY',
    longDateTime: 'MM/DD/YYYY h:mmA',
    longDateTimePlusSecondsAmPm: 'MMMM Do YYYY, h:mm:ss a',
    longTime: 'h:mmA',
    shortTime: 'h:mm',
    dayAndMonth: 'DD MMMM',
    dayAndMonthInverse: 'MMMM DD',
    dayAndMonthShort: 'DD MMM',
    dayName: 'dddd',
    dayNameDayAndMonth: 'ddd M/D',
    dayMonthAndYear: 'MMM DD, YYYY'
  },
  cdu: {
    default: {
      brand: 'default',
      group2ColumnEventsBy: (window.ctsautoconf && window.ctsautoconf.group2ColumnEventsBy) || 'DEFAULT',
      standard: {
        maxNumOfLines: 5,
        maxNumOfLines2Column: 5,
        maxNumOfLines2ColumnsameSport: 5.5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 12
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 6,
        maxNumOfLines2ColumnsameSport: 6.5,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 4,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9
      },
      urlParamToBig3MarketMap: {
        1: 'ML',
        2: 'TP',
        3: 'PS'
      },
      showParticipantLogos: false
    },
    pinegreen: {
      brand: 'pinegreen',
      group2ColumnEventsBy: (window.ctsautoconf && window.ctsautoconf.group2ColumnEventsBy) || 'DEFAULT',
      standard: {
        maxNumOfLines: 5,
        maxNumOfLines2Column: 5,
        maxNumOfLines2ColumnsameSport: 5.5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 12
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 6,
        maxNumOfLines2ColumnsameSport: 6.5,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 4,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9
      },
      urlParamToBig3MarketMap: {
        1: 'ML',
        2: 'TP',
        3: 'PS'
      },
      showParticipantLogos: false
    },
    darkviolet: {
      brand: 'darkviolet',
      group2ColumnEventsBy: (window.ctsautoconf && window.ctsautoconf.group2ColumnEventsBy) || 'DEFAULT',
      standard: {
        maxNumOfLines: 5,
        maxNumOfLines2Column: 5,
        maxNumOfLines2ColumnsameSport: 5.5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 12
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 6,
        maxNumOfLines2ColumnsameSport: 6.5,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 4,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9
      },
      urlParamToBig3MarketMap: {
        1: 'ML',
        2: 'TP',
        3: 'PS'
      },
      showParticipantLogos: false
    },
    white1: {
      brand: 'white1',
      group2ColumnEventsBy: 'DATE',
      standard: {
        maxNumOfLines: 5,
        maxNumOfLines2Column: 5,
        maxNumOfLines2ColumnsameSport: 5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 7,
        maxNumOfLines2ColumnsameSport: 7,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 3,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      urlParamToBig3MarketMap: {
        3: 'PS',
        2: 'ML',
        1: 'TP'
      },
      showParticipantLogos: true,
      showParticipantStats: true
    },
    translux3: {
      brand: 'translux3',
      group2ColumnEventsBy: (window.ctsautoconf && window.ctsautoconf.group2ColumnEventsBy) || 'DEFAULT',
      standard: {
        maxNumOfLines: 4,
        maxNumOfLines2Column: 4,
        maxNumOfLines2ColumnsameSport: 4.5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 12,
        noHeaderHeightRation2Column: 0.8,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 7,
        maxNumOfLines2ColumnsameSport: 7,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 3,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      urlParamToBig3MarketMap: {
        3: 'ML',
        2: 'PS',
        1: 'TP'
      },
      showParticipantLogos: false
    },
    translux4: {
      brand: 'translux4',
      group2ColumnEventsBy: (window.ctsautoconf && window.ctsautoconf.group2ColumnEventsBy) || 'DEFAULT',
      standard: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 4,
        maxNumOfLines2ColumnsameSport: 4.5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 16,
        noHeaderHeightRation2Column: 0.8,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 7,
        maxNumOfLines2ColumnsameSport: 7,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 3,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      urlParamToBig3MarketMap: {
        3: 'ML',
        2: 'PS',
        1: 'TP'
      },
      showParticipantLogos: false
    },
    translux5: {
      brand: 'translux5',
      group2ColumnEventsBy: 'DATE',
      standard: {
        maxNumOfLines: 5,
        maxNumOfLines2Column: 5,
        maxNumOfLines2ColumnsameSport: 5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 7,
        maxNumOfLines2ColumnsameSport: 7,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 3,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      urlParamToBig3MarketMap: {
        3: 'PS',
        2: 'ML',
        1: 'TP'
      },
      showParticipantLogos: true
    },
    ultrawide: {
      brand: 'ultrawide',
      group2ColumnEventsBy: 'DATE',
      standard: {
        maxNumOfLines: 5,
        maxNumOfLines2Column: 5,
        maxNumOfLines2ColumnsameSport: 5,
        maxNumOfPopularSelections: 14,
        maxNumOfExpandedLineSelections: 20,
        resultedEventRowSize: 0.33,
        numOfOutrightSelectionsColumns: 4,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      small: {
        maxNumOfLines: 6,
        maxNumOfLines2Column: 7,
        maxNumOfLines2ColumnsameSport: 7,
        maxNumOfPopularSelections: 18,
        maxNumOfExpandedLineSelections: 25,
        resultedEventRowSize: 0.25,
        numOfOutrightSelectionsColumns: 5,
        maxNumOfOutrightSelectionsInColumn: 15,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      big: {
        maxNumOfLines: 3,
        maxNumOfLines2Column: 3,
        maxNumOfLines2ColumnsameSport: 3,
        maxNumOfPopularSelections: 7,
        maxNumOfExpandedLineSelections: 13,
        resultedEventRowSize: 0.5,
        numOfOutrightSelectionsColumns: 2,
        maxNumOfOutrightSelectionsInColumn: 9,
        noHeaderHeightRation2Column: 0.9,
        maxNumOfSelectionsPerColSingleEvent: 13.35
      },
      urlParamToBig3MarketMap: {
        3: 'PS',
        2: 'ML',
        1: 'TP'
      },
      showParticipantLogos: true
    }
  },
  brands: {
    default: 'default',
    white: 'white',
    white1: 'white1',
    pinegreen: 'pinegreen',
    darkviolet: 'darkviolet',
    translux: 'translux',
    translux1: 'translux1',
    translux2: 'translux2',
    translux3: 'translux3',
    translux4: 'translux4',
    translux5: 'translux5',
    ultrawide: 'ultrawide'
  }
}



// WEBPACK FOOTER //
// ./src/config/app.js